var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx:support",
    clipPath: "url(#clip0_1756_22115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0037 0.800781C9.41683 0.800781 0.803711 9.4139 0.803711 20.0008V27.9553C0.803711 29.9214 2.52595 31.5208 4.64371 31.5208H6.56371C7.07293 31.5208 7.56129 31.3185 7.92136 30.9584C8.28143 30.5984 8.48371 30.11 8.48371 29.6008V19.7262C8.48371 19.217 8.28143 18.7286 7.92136 18.3686C7.56129 18.0085 7.07293 17.8062 6.56371 17.8062H4.82035C5.88787 10.3758 12.2815 4.64078 20.0037 4.64078C27.726 4.64078 34.1196 10.3758 35.1871 17.8062H33.4437C32.9345 17.8062 32.4461 18.0085 32.0861 18.3686C31.726 18.7286 31.5237 19.217 31.5237 19.7262V31.5208C31.5237 33.6385 29.8015 35.3608 27.6837 35.3608H23.8437V33.4408H16.1637V39.2008H27.6837C31.9192 39.2008 35.3637 35.7563 35.3637 31.5208C37.4815 31.5208 39.2037 29.9214 39.2037 27.9553V20.0008C39.2037 9.4139 30.5906 0.800781 20.0037 0.800781Z",
    fill: "#F7FBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1756_22115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 38.4,
    fill: "white",
    transform: "translate(0.803223 0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/Support-Icon.e4f47d0d6c0cc480ecc625a244e3dd90.svg";
export { ForwardRef as ReactComponent };